import { FormControl, FormHelperText, TextField } from '@mui/material';

interface TxtSexoProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  helperText?: string;
  required?: boolean;
  name?: string;
  disabled?: boolean;
}

export const TxtSexo = ({ value, onChange, helperText, required = false, name = 'sexo', disabled = false }: TxtSexoProps) => {
  return (
    <FormControl fullWidth size="small">
      <TextField size="small" select required={required} name={name} value={value} disabled={disabled} onChange={onChange} SelectProps={{ native: true }}>
        <option value="">Selecione</option>
        <option value="Masculino">Masculino</option>
        <option value="Feminino">Feminino</option>
      </TextField>

      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
